import React, { useState } from 'react';
import { Play, ArrowRight, List, GraduationCap, Phone, Mail, MapPin, Clock, Send, Loader } from 'lucide-react';
import { G1, G2, GG, INP, LBL, SS, NavyBg, PAGE_ROOT } from '../../config/styles';
import { Spin, DrivePlayer, SmartIntro } from '../shared';

// ── Agency ──────────────────────────────────
export function Agency({ services, lang, loading, t, onSetPage, onOpenWA, isRTL }) {
  return (
    <div>
      <div style={{ textAlign: 'center', color: 'white', marginBottom: '32px' }}>
        <h2 style={{ fontSize: '40px', fontWeight: 'bold', textShadow: '2px 2px 12px rgba(0,0,0,0.2)' }}>💼 {t.agency}</h2>
        <p style={{ opacity: 0.85, fontSize: '15px', marginTop: '6px' }}>{services.length} {lang === 'ar' ? 'خدمة احترافية' : 'professional services'}</p>
      </div>
      {loading ? <Spin /> : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(250px,1fr))', gap: '20px' }}>
          {services.map(s => (
            <div key={s.id} style={{ background: 'white', borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 32px rgba(118,75,162,0.2)', transition: 'all .3s cubic-bezier(.34,1.56,.64,1)' }}
              onMouseEnter={e => e.currentTarget.style.transform = 'translateY(-8px)'}
              onMouseLeave={e => e.currentTarget.style.transform = 'translateY(0)'}>
              <div style={{ background: G2, padding: '28px', textAlign: 'center', position: 'relative', overflow: 'hidden' }}>
                <div style={{ position: 'absolute', top: '-20px', [isRTL ? 'left' : 'right']: '-20px', fontSize: '80px', opacity: 0.12 }}>{s.icon}</div>
                <div style={{ fontSize: '52px', filter: 'drop-shadow(0 4px 8px rgba(0,0,0,0.2))' }}>{s.icon}</div>
                <h3 style={{ color: 'white', fontSize: '16px', fontWeight: 'bold', marginTop: '8px' }}>{lang === 'ar' ? s.name_ar : s.name_en}</h3>
              </div>
              <div style={{ padding: '18px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                  <span style={{ color: '#6B7280', fontSize: '13px' }}>{t.from}</span>
                  <span style={{ fontSize: '24px', fontWeight: 'bold', color: '#764ba2' }}>${s.price}</span>
                </div>
                <button onClick={onOpenWA} style={{ width: '100%', padding: '11px', background: G2, color: 'white', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer', boxShadow: '0 4px 12px rgba(118,75,162,0.35)' }}>{t.requestService}</button>
              </div>
            </div>
          ))}
        </div>
      )}
      <div style={{ textAlign: 'center', marginTop: '32px' }}>
        <button onClick={() => onSetPage('home')} style={{ padding: '11px 28px', background: 'rgba(255,255,255,0.95)', color: '#764ba2', border: 'none', borderRadius: '10px', fontSize: '14px', cursor: 'pointer', fontWeight: 'bold' }}>{t.backHome}</button>
      </div>
    </div>
  );
}

// ── Player ──────────────────────────────────
export function Player({ activeCourse, activeLesson, setActiveLesson, lessons, lang, isRTL, t, onBack }) {
  const cLessons = (cid) => lessons.filter(l => l.course_id === cid).sort((a, b) => a.order_num - b.order_num);
  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', color: 'white', marginBottom: '20px', flexWrap: 'wrap' }}>
        <button onClick={onBack} style={{ background: 'rgba(255,255,255,0.2)', backdropFilter: 'blur(6px)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: '10px', padding: '8px 14px', color: 'white', cursor: 'pointer', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '5px' }}>
          <ArrowRight size={14} style={{ transform: isRTL ? 'none' : 'rotate(180deg)' }} /> {t.backHome}
        </button>
        <h2 style={{ fontSize: '20px', fontWeight: 'bold', margin: 0 }}>{lang === 'ar' ? activeCourse.name_ar : activeCourse.name_en}</h2>
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 300px', gap: '18px' }}>
        <div>
          {activeLesson ? (
            <>
              <h3 style={{ color: 'white', fontSize: '16px', fontWeight: 'bold', margin: '0 0 10px' }}>{lang === 'ar' ? activeLesson.title_ar : activeLesson.title_en}</h3>
              <DrivePlayer fileId={activeLesson.drive_file_id} />
            </>
          ) : activeCourse.drive_intro_id ? (
            <>
              <h3 style={{ color: 'white', fontSize: '16px', fontWeight: 'bold', marginBottom: '10px' }}>{t.introVideo}</h3>
              <SmartIntro src={activeCourse.drive_intro_id} />
            </>
          ) : null}
        </div>
        <div style={{ background: 'white', borderRadius: '14px', overflow: 'hidden', maxHeight: '480px', overflowY: 'auto' }}>
          <div style={{ padding: '14px 16px', background: G1, color: 'white', fontWeight: 'bold', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <List size={15} /> {t.courseContent}
          </div>
          {cLessons(activeCourse.id).map((lesson, idx) => {
            const active = activeLesson?.id === lesson.id;
            return (
              <div key={lesson.id} onClick={() => setActiveLesson(lesson)}
                style={{ padding: '12px 16px', borderBottom: '1px solid #F3F4F6', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '10px', background: active ? '#EEF2FF' : 'white' }}
                onMouseEnter={e => { if (!active) e.currentTarget.style.background = '#F9FAFB'; }}
                onMouseLeave={e => { if (!active) e.currentTarget.style.background = 'white'; }}>
                <div style={{ width: '26px', height: '26px', borderRadius: '50%', background: active ? G1 : '#F3F4F6', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                  {active ? <Play size={11} color="white" /> : <span style={{ fontSize: '11px', color: '#6B7280', fontWeight: 'bold' }}>{idx + 1}</span>}
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: '12px', fontWeight: 'bold', color: active ? '#667eea' : '#1F2937', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{lang === 'ar' ? lesson.title_ar : lesson.title_en}</div>
                  {lesson.duration && <div style={{ fontSize: '10px', color: '#9CA3AF' }}>{lesson.duration}</div>}
                </div>
                {lesson.is_free && <span style={{ fontSize: '9px', background: '#D1FAE5', color: '#059669', padding: '1px 5px', borderRadius: '4px', fontWeight: 'bold' }}>{t.free}</span>}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

// ── MyCourses ────────────────────────────────
export function MyCourses({ customer, enrollments, courses, lessons, lang, t, onSetPage, onGoPlayer }) {
  const cLessons = (cid) => lessons.filter(l => l.course_id === cid).sort((a, b) => a.order_num - b.order_num);
  const myEnr = enrollments.filter(e => e.customer_id === customer?.id && e.status === 'active');

  return (
    <div>
      <div style={{ textAlign: 'center', color: 'white', marginBottom: '28px' }}>
        <h2 style={{ fontSize: '36px', fontWeight: 'bold' }}>{t.myCoursesTitle}</h2>
      </div>
      {!myEnr.length ? (
        <div style={{ textAlign: 'center', background: 'rgba(255,255,255,0.15)', borderRadius: '18px', padding: '50px 24px', backdropFilter: 'blur(10px)', border: '1px solid rgba(255,255,255,0.2)' }}>
          <div style={{ fontSize: '56px', marginBottom: '14px' }}>📚</div>
          <p style={{ color: 'white', fontSize: '16px', marginBottom: '18px' }}>{t.noEnrolledCourses}</p>
          <button onClick={() => onSetPage('academy')} style={{ padding: '10px 24px', background: 'white', color: '#667eea', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: 'bold', cursor: 'pointer', display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
            <GraduationCap size={16} /> {t.browseCoursesBtn}
          </button>
        </div>
      ) : (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))', gap: '18px' }}>
          {myEnr.map(enr => {
            const course = courses.find(c => c.id === enr.course_id);
            if (!course) return null;
            const cl = cLessons(course.id);
            return (
              <div key={enr.id} style={{ background: 'white', borderRadius: '18px', overflow: 'hidden', boxShadow: '0 8px 24px rgba(0,0,0,0.14)' }}>
                <div style={{ background: G1, padding: '20px', position: 'relative', overflow: 'hidden' }}>
                  <div style={{ position: 'absolute', top: '-15px', right: '-15px', fontSize: '70px', opacity: 0.12 }}>{course.icon}</div>
                  <div style={{ fontSize: '32px', marginBottom: '6px' }}>{course.icon}</div>
                  <h3 style={{ color: 'white', fontSize: '16px', fontWeight: 'bold', margin: 0 }}>{lang === 'ar' ? course.name_ar : course.name_en}</h3>
                  <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '11px', marginTop: '4px' }}>{cl.length} {t.lessons}</div>
                </div>
                <div style={{ padding: '16px' }}>
                  <div style={{ maxHeight: '150px', overflowY: 'auto', marginBottom: '12px' }}>
                    {cl.map((lesson, idx) => (
                      <div key={lesson.id} onClick={() => onGoPlayer(course, lesson)}
                        style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '7px 8px', borderRadius: '6px', cursor: 'pointer' }}
                        onMouseEnter={e => e.currentTarget.style.background = '#F9FAFB'}
                        onMouseLeave={e => e.currentTarget.style.background = 'transparent'}>
                        <div style={{ width: '20px', height: '20px', borderRadius: '50%', background: '#EEF2FF', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                          <span style={{ fontSize: '10px', color: '#667eea', fontWeight: 'bold' }}>{idx + 1}</span>
                        </div>
                        <span style={{ fontSize: '12px', color: '#374151', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{lang === 'ar' ? lesson.title_ar : lesson.title_en}</span>
                        <Play size={11} color="#667eea" />
                      </div>
                    ))}
                  </div>
                  <button onClick={() => onGoPlayer(course, cl[0] || null)}
                    style={{ width: '100%', padding: '10px', background: G1, color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' }}>
                    <Play size={13} /> {t.startLearning}
                  </button>
                </div>
              </div>
            );
          })}
        </div>
      )}
      <div style={{ textAlign: 'center', marginTop: '28px' }}>
        <button onClick={() => onSetPage('home')} style={{ padding: '10px 24px', background: 'rgba(255,255,255,0.95)', color: '#667eea', border: 'none', borderRadius: '8px', fontSize: '14px', cursor: 'pointer', fontWeight: 'bold' }}>{t.backHome}</button>
      </div>
    </div>
  );
}

// ── Contact ──────────────────────────────────
export function Contact({ settings, lang, isRTL, t, onSetPage, onOpenWA, addContactMessage, showToast }) {
  const ar = lang === 'ar';
  const [form, setForm]       = useState({ name: '', email: '', phone: '', service: '', message: '' });
  const [sent, setSent]       = useState(false);
  const [load, setLoad]       = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setLoad(true);
    const { error } = await addContactMessage(form);
    setLoad(false);
    if (!error) setSent(true);
  };

  const ORANGE = '#f97316';
  const OGRAD  = 'linear-gradient(135deg,#f97316,#fb923c)';

  return (
    <div style={PAGE_ROOT}>
      <NavyBg />

      <div style={{ textAlign: 'center', color: 'white', marginBottom: '32px', animation: 'fadeInDown .6s ease both' }}>
        <h2 style={{ fontSize: '40px', fontWeight: 'bold', textShadow: '2px 2px 12px rgba(0,0,0,0.25)' }}>📬 {t.contact}</h2>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 340px', gap: '20px', maxWidth: '960px', margin: '0 auto' }} className="contact-grid">
        {/* Form */}
        <div style={{ background: 'white', borderRadius: '20px', padding: '28px', boxShadow: '0 14px 40px rgba(0,0,0,0.3)', animation: 'cardRise .55s ease both' }}>
          <h3 style={{ fontSize: '18px', fontWeight: 'bold', color: '#1F2937', marginBottom: '20px', display: 'flex', alignItems: 'center', gap: '8px' }}>
            <Send size={18} style={{ color: ORANGE }} /> {ar ? 'ابعت رسالة' : 'Send a message'}
          </h3>
          {sent ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <div style={{ fontSize: '52px', marginBottom: '14px' }}>✅</div>
              <p style={{ fontSize: '16px', fontWeight: 'bold', color: '#059669' }}>{t.contactDone}</p>
              <button onClick={() => { setSent(false); setForm({ name: '', email: '', phone: '', service: '', message: '' }); }}
                style={{ marginTop: '14px', padding: '9px 20px', background: OGRAD, color: 'white', border: 'none', borderRadius: '8px', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}>
                {ar ? 'إرسال رسالة أخرى' : 'Send another'}
              </button>
            </div>
          ) : (
            <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '14px' }}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '12px' }}>
                <div><label style={LBL}>{t.name} *</label><input value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required placeholder={t.enterName} style={INP} /></div>
                <div><label style={LBL}>{t.phone}</label><input value={form.phone} onChange={e => setForm({ ...form, phone: e.target.value })} placeholder={t.enterPhone} type="tel" style={INP} /></div>
              </div>
              <div><label style={LBL}>{t.email} *</label><input value={form.email} onChange={e => setForm({ ...form, email: e.target.value })} required type="email" placeholder={t.enterEmail} style={INP} /></div>
              <div>
                <label style={LBL}>{ar ? 'الخدمة المطلوبة' : 'Service'}</label>
                <select value={form.service} onChange={e => setForm({ ...form, service: e.target.value })} style={{ ...INP, cursor: 'pointer' }}>
                  <option value="">{ar ? '-- اختر --' : '-- Select --'}</option>
                  {t.serviceOptions.map((s, i) => <option key={i} value={s}>{s}</option>)}
                </select>
              </div>
              <div><label style={LBL}>{ar ? 'رسالتك *' : 'Your message *'}</label><textarea value={form.message} onChange={e => setForm({ ...form, message: e.target.value })} required rows="4" placeholder={ar ? 'اكتب رسالتك...' : 'Type your message...'} style={{ ...INP, resize: 'vertical' }} /></div>
              <button type="submit" disabled={load}
                style={{ padding: '12px', background: load ? '#9CA3AF' : OGRAD, color: 'white', border: 'none', borderRadius: '10px', fontSize: '14px', fontWeight: 'bold', cursor: load ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxShadow: '0 4px 14px rgba(249,115,22,0.4)' }}>
                {load ? <><Loader size={15} style={SS} /> {t.contactSending}</> : <><Send size={15} /> {t.contactSend}</>}
              </button>
            </form>
          )}
        </div>

        {/* Sidebar */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: '14px', animation: 'cardRise .55s ease both', animationDelay: '0.1s' }}>
          <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '20px', padding: '24px', boxShadow: '0 10px 30px rgba(0,0,0,0.28)' }}>
            <h3 style={{ fontSize: '16px', fontWeight: 'bold', color: '#fff', marginBottom: '16px' }}>{t.contactInfo}</h3>
            {[
              { icon: <Phone size={16} color={ORANGE} />, label: ar ? 'واتساب' : 'WhatsApp', val: settings.whatsapp_number, href: `https://wa.me/${settings.whatsapp_number?.replace(/\D/g, '')}` },
              { icon: <Mail  size={16} color={ORANGE} />, label: ar ? 'البريد' : 'Email', val: settings.email_contact || 'info@gawhara.com', href: `mailto:${settings.email_contact || 'info@gawhara.com'}` },
              { icon: <MapPin size={16} color={ORANGE} />, label: t.contactAddress, val: settings.address || 'القاهرة، مصر', href: null },
              { icon: <Clock  size={16} color={ORANGE} />, label: t.contactHours, val: t.contactHoursVal, href: null },
            ].map((item, i) => (
              <div key={i} style={{ display: 'flex', gap: '10px', alignItems: 'flex-start', marginBottom: '12px' }}>
                <div style={{ width: '34px', height: '34px', background: 'rgba(249,115,22,0.14)', borderRadius: '9px', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{item.icon}</div>
                <div>
                  <div style={{ fontSize: '11px', color: 'rgba(255,255,255,0.5)', marginBottom: '1px' }}>{item.label}</div>
                  {item.href
                    ? <a href={item.href} target="_blank" rel="noreferrer" style={{ fontSize: '13px', color: '#fb923c', fontWeight: 'bold', textDecoration: 'none' }}>{item.val}</a>
                    : <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.85)', fontWeight: 'bold' }}>{item.val}</div>
                  }
                </div>
              </div>
            ))}
          </div>
          <div style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: '18px', padding: '20px', boxShadow: '0 10px 30px rgba(0,0,0,0.28)' }}>
            <h3 style={{ fontSize: '14px', fontWeight: 'bold', color: '#fff', marginBottom: '12px' }}>{t.contactSocial}</h3>
            {[
              { emoji: '📘', label: 'Facebook', url: settings.facebook_url, color: '#60a5fa' },
              { emoji: '📸', label: 'Instagram', url: settings.instagram_url, color: '#f472b6' },
              { emoji: '▶️', label: 'YouTube', url: settings.youtube_url, color: '#f87171' },
            ].map((s, i) => s.url ? (
              <a key={i} href={s.url} target="_blank" rel="noreferrer"
                style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 11px', background: 'rgba(255,255,255,0.04)', borderRadius: '9px', textDecoration: 'none', border: '1px solid rgba(255,255,255,0.08)', marginBottom: '6px', transition: 'background .2s' }}
                onMouseEnter={e => e.currentTarget.style.background = 'rgba(249,115,22,0.12)'}
                onMouseLeave={e => e.currentTarget.style.background = 'rgba(255,255,255,0.04)'}>
                <span style={{ fontSize: '18px' }}>{s.emoji}</span>
                <span style={{ fontSize: '13px', fontWeight: 'bold', color: s.color }}>{s.label}</span>
              </a>
            ) : (
              <div key={i} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '9px 11px', background: 'rgba(255,255,255,0.02)', borderRadius: '9px', border: '1px solid rgba(255,255,255,0.06)', marginBottom: '6px', opacity: 0.45 }}>
                <span style={{ fontSize: '18px' }}>{s.emoji}</span>
                <span style={{ fontSize: '13px', color: 'rgba(255,255,255,0.5)' }}>{s.label}</span>
              </div>
            ))}
          </div>
          <button onClick={onOpenWA} style={{ padding: '14px', background: 'linear-gradient(135deg,#25D366,#128C7E)', color: 'white', border: 'none', borderRadius: '14px', fontSize: '15px', fontWeight: 'bold', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', boxShadow: '0 6px 18px rgba(37,211,102,0.4)' }}>
            💬 {ar ? 'تكلم معنا على واتساب' : 'Chat with us on WhatsApp'}
          </button>
        </div>
      </div>

      {/* موبايل: عمود واحد */}
      <style>{`
        @media (max-width: 760px){ .contact-grid{ grid-template-columns: 1fr !important; } }
      `}</style>

      <div style={{ textAlign: 'center', marginTop: '28px' }}>
        <button onClick={() => onSetPage('home')} style={{ padding: '11px 26px', background: 'rgba(255,255,255,0.95)', color: ORANGE, border: 'none', borderRadius: '10px', fontSize: '14px', cursor: 'pointer', fontWeight: 'bold', boxShadow: '0 4px 16px rgba(0,0,0,0.18)' }}>{t.backHome}</button>
      </div>
    </div>
  );
}
